import { createApiSlice } from "@common/common-slice/commonSlice";

import {
  CRUD_SKILL_MAPPING,
  CRUD_SKILL_MAPPING_SETUP,
  DELETE_SKILL_MAPPING_QUESTION_TYPE_BY_ID,
  DELETE_SKILL_MAPPING_QUESTION_CONFIG_TYPE_BY_ID,
  DIFFICULTY_LEVEL_MARKS, DIFFICULTY_LEVEL_MARKS_SETUP,
  GET_ALL_SKILL,
  GET_SKILL_MAPPING_BY_ID,
  GET_SKILL_MAPPING_BY_ID_SETUP,
  GET_SKILL_MAPPING_DETAILS,
  GET_SKILL_MAPPING_DETAILS_SETUP,
  VALIDATE_MARKS_DURATION,
  VALIDATE_MARKS_DURATION_CONFIG
} from "@routes";

const apiConfig = [
  {
    name: "createSkillMapping",
    method: "post",
    url: CRUD_SKILL_MAPPING,
    stateKey: "message",
  },
  {
    name: "getSkillMappingById",
    method: "get",
    url: GET_SKILL_MAPPING_BY_ID,
    stateKey: "skillMappingData",
  },
  {
    name: "getSkillMappingDetails",
    method: "get",
    url: GET_SKILL_MAPPING_DETAILS,
    stateKey: "details",
  },
  {
    name: "updateSkillMapping",
    method: "put",
    url: CRUD_SKILL_MAPPING,
    stateKey: "message",
  },
  {
    name: "deleteSkillMapping",
    method: "delete",
    url: CRUD_SKILL_MAPPING,
    stateKey: "message",
  },

  // -----------------------------------------------------------------
  // VALIDATION 
  // -----------------------------------------------------------------
  {
    name: "validateMarksDuration",
    method: "post",
    url: VALIDATE_MARKS_DURATION,
    stateKey: "validateData",
  },
  {
    name: "difficultyLevelMarks",
    method: "post",
    url: DIFFICULTY_LEVEL_MARKS,
    stateKey: "difficultyData",
  },

  // -----------------------------------------------------------------
  // SKILL
  // -----------------------------------------------------------------

  {
    name: "getAllSkill",
    method: "get",
    url: GET_ALL_SKILL,
    stateKey: "skillData",
  },

  // -----------------------------------------------------------------
  // QUESTION TYPE DELETE
  // -----------------------------------------------------------------

  {
    name: "deleteQuestionTypeById",
    method: "delete",
    url: DELETE_SKILL_MAPPING_QUESTION_TYPE_BY_ID,
    stateKey: "message",
  },
  {
    name: "deleteQuestionTypeConfigById",
    method: "delete",
    url: DELETE_SKILL_MAPPING_QUESTION_CONFIG_TYPE_BY_ID,
    stateKey: "message",
  },


  // setup skill mapping
  {
    name: "createSkillMappingSetup",
    method: "post",
    url: CRUD_SKILL_MAPPING_SETUP,
    stateKey: "message",
  },
  {
    name: "getSkillMappingByIdSetup",
    method: "get",
    url: GET_SKILL_MAPPING_BY_ID_SETUP,
    stateKey: "skillMappingDataSetup",
  },
  {
    name: "getSkillMappingDetailsSetup",
    method: "get",
    url: GET_SKILL_MAPPING_DETAILS_SETUP,
    stateKey: "detailsSetup",
  },
  {
    name: "updateSkillMappingSetup",
    method: "put",
    url: CRUD_SKILL_MAPPING_SETUP,
    stateKey: "message",
  },
  {
    name: "deleteSkillMappingSetup",
    method: "delete",
    url: CRUD_SKILL_MAPPING_SETUP,
    stateKey: "message",
  },

  // -----------------------------------------------------------------
  // VALIDATION SETUP
  // -----------------------------------------------------------------

  {
    name: "validateMarksDurationSetup",
    method: "post",
    url: VALIDATE_MARKS_DURATION_CONFIG,
    stateKey: "validateDataSetup",
  },
  {
    name: "difficultyLevelMarksSetup",
    method: "post",
    url: DIFFICULTY_LEVEL_MARKS_SETUP,
    stateKey: "difficultyDataSetup",
  },

];

const customReducers = {
  initialState: {
    skillMappingData: [],
    details: [],
    detailsSetup: [],
    validateData: [],
    validateDataSetup: [],
    difficultyData: [],
    difficultyDataSetup: [],
    skillData: [],
    skillMappingDataSetup: [],
    selectedDataSkill: {},
    selectedSkillData: {},
  },
  reducers: {
    // these two reducers for removing the redux data of displaying the Duration, MaxScore and Question progress data
    resetDifficultyData: (state) => {
      state.difficultyData = null; // or your initial state default
    },
    resetWeightageData: (state) => {
      state.validateData = null; // or your initial state default
    },

    // setup
    resetDifficultyDataSetup: (state) => {
      state.difficultyDataSetup = null; // or your initial state default
    },
    resetWeightageDataSetup: (state) => {
      state.validateDataSetup = null; // or your initial state default
    }
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "skillMapping",
  apiConfig,
  customReducers,
);

const skillMappingSlice = slice;

export default skillMappingSlice.reducer;

export const {
  createSkillMapping,
  createSkillMappingSetup,
  getSkillMappingDetailsSetup,
  getSkillMappingByIdSetup,
  updateSkillMappingSetup,
  deleteSkillMappingSetup,
  getSkillMappingById,
  getSkillMappingDetails,
  updateSkillMapping,
  deleteSkillMapping,
  validateMarksDuration,
  validateMarksDurationSetup,
  difficultyLevelMarks,
  difficultyLevelMarksSetup,
  getAllSkill,
  deleteQuestionTypeById,
  deleteQuestionTypeConfigById,
} = thunks;

export const {
  resetMessage,
  resetErrMessage,
  rowSelect,

  // App reset
  resetDifficultyData,
  resetWeightageData,

  // setup reset
  resetDifficultyDataSetup,
  resetWeightageDataSetup
} = actions;